<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Atendimentos"
      Pagina="Atendimento"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-12">
            <div class="row">
              <div class="col-md-12 text-right" style="margin-bottom: 10px;">
                <button class="btn btn-primary" (click)="abrirModal()"><i class="fa fa-plus"></i> Cadastrar</button>
              </div>
              <div class="col-md-12">
                <div class="card card-blue" style="margin-top:10px;padding-top: 7px">
                  <div class="card-header">
                    <h3 class="card-title">Atendimentos</h3>
                  </div>
                  <div class="card-body table-responsive p-0">
                    <table class="table table-hover table-borderless table-head-fixed table-striped text-nowrap">
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>Solicitante</th>
                          <th>Descrição</th>
                          <th>Data</th>
                          <th style="width: 20px">*</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of listaAtendimento.itens | paginate: { itemsPerPage: 6, currentPage: paginaAtual }">
                          <td>{{item.id}}</td>
                          <td>{{item.solicitante}}</td>
                          <td>{{item.descricaoResumida}}</td>
                          <td>{{item.dataCadastro | date: 'dd/MM/yyyy'}}</td>
                          <td>
                            <button class="btn btn-warning" (click)="abrirModalDetalhes(item.id)"><i class="fa fa-edit"></i></button>
                          </td>
                        </tr>
                        <tr *ngIf="listaAtendimento.itens.length == 0">
                          <td colspan="5" class="text-center text-orange">Nenhum registro a ser mostrado</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="card-footer clearfix text-center" *ngIf="listaAtendimento.itens.length > 0">
                    <pagination-controls class="pagination-sm"
                                         [autoHide]="false"
                                         [directionLinks]="true"
                                         previousLabel="Anterior"
                                         nextLabel="Próximo"
                                         (pageChange)="paginaAtual = $event">
                    </pagination-controls>
                  </div>
                </div>
              </div>
            </div>
      </div>
    </div>
  </section>
</div>
<app-novo-atendimento [isModal]="true" (atualizarLista)="buscarListaAtendimentos()"></app-novo-atendimento>
<app-detalhes [isModal]="true" (atualizarLista)="buscarListaAtendimentos()"></app-detalhes>
